import SharedProcessingTimeSection from "@/components/feature/SharedProcessingTimeSection";
import type { ProcessingOption } from "@/components/feature/SharedProcessingTimeSection";

const options: ProcessingOption[] = [
  {
    speed: "2–9",
    unit: "Business Days",
    label: "Fast Passport Center",
    tag: "Most Popular",
    tagColor: "bg-[#F6C344] text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission",
      "Predictable turnaround",
      "Ideal for upcoming trips",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: true,
  },
  {
    speed: "3–5",
    unit: "Weeks",
    label: "Fast Passport Center",
    tag: "Standard Expedited",
    tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission",
      "Faster than self-service",
      "Good for planned travel",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: false,
    smartSaver: true,
  },
  {
    speed: "1–2",
    unit: "Months",
    label: "Self-Service (Post Office)",
    tag: "Slowest",
    tagColor: "bg-gray-100 text-gray-400",
    features: [
      "No courier access — standard mail only",
      "Workload & wait times shift with shutdowns and budget fights",
      "In-person clerk appointment required",
      "No document review — errors cause rejection",
      "No dedicated agent — you are on your own",
      "Updates only by physical mail letter",
      "No phone or email contact for your case",
      "Can't upgrade speed after submission",
      "Not suitable if travel is within 10 weeks",
    ],
    highlight: false,
    muted: true,
  },
  {
    speed: "24",
    unit: "Hours*",
    label: "Regional Agency Processing",
    tag: "Emergency Only",
    tagColor: "bg-gray-100 text-gray-500",
    features: [
      "Appointment required — no walk-ins allowed",
      "Life-or-death emergencies only",
      "Bereavement or medical crisis",
      "Expect to wait all day or return next day",
    ],
    highlight: false,
    emergency: true,
  },
];

export default function BloomingtonProcessingTimeSection() {
  return (
    <SharedProcessingTimeSection
      sectionId="processing-options"
      cityName="Bloomington"
      headingExtra="MN"
      introText="Bloomington is home to the Mall of America and borders MSP International Airport — thousands of international travelers pass through daily, many discovering expired passports at the gate. The nearest regional passport agency is the Chicago Passport Agency at 230 S Dearborn St, Suite 380 — approximately 400 miles southeast. Here's how Bloomington travelers compare their options, and why MSP-area residents choose a courier over the 6-hour drive to Chicago."
      options={options}
      emergencyDescription="Chicago is about 400 miles from Bloomington — but the distance is deceptive when you need a passport fast. MSP International Airport generates thousands of same-day international departures from Bloomington's doorstep. A traveler discovering an expired passport at the gate has exactly one regional option: the Chicago Passport Agency at 230 S Dearborn St Suite 380, serving Minnesota plus the Dakotas, Iowa, and Wisconsin. That's a 6+ hour drive through potential winter weather — and the Chicago agency serves the entire Upper Midwest, meaning appointment competition is year-round fierce, not seasonal."
      disclaimerText="*Processing speed depends on eligibility and documentation. Not all applicants qualify for Regional Agency Processing. Nearest agency: Chicago Passport Agency at 230 S Dearborn St, Suite 380, Chicago, IL 60604 — approximately 400 miles southeast of Bloomington."
    />
  );
}